module.exports = __webpack_public_path__ + "static/media/grampa.5d752590.jpg";